import React, { useState, useEffect } from "react";
import { Link as RouterLink, useParams, useLocation, useNavigate } from "react-router-dom";
// material
import {
    FormGroup, FormControlLabel, Checkbox, Stack, Card, TextField, Divider, Table, Button, TableRow, TableBody, TableCell, Container, Typography, TableContainer, TablePagination, Modal, Box, TableHead,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import Page from "../../components/Page";
import Scrollbar from "../../components/Scrollbar";
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { UserListHead } from "../../sections/@dashboard/user";
import { GetPoolListAction, AddPoolAction, PoolChangeStatusAction, ResetAddPoolAction } from "../../redux/actions/MatchAction";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import HeaderBreadcrumbs from "../../components/HeaderBreadcrumbs";
import Grid from "@mui/material/Unstable_Grid2";
import { Delete } from "@mui/icons-material";
import Loader from "src/components/Loader";
import Iconify from "../../components/Iconify";

export default function Pool() {
    let { id } = useParams();
    const dispatch = useDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);
    const [openPzBk, setOpenPzBk] = useState(false);
    const loadingSelector = useSelector(state => state.matches.loading)
    const statusSelector = useSelector(state => state.matches.pool_status)
    const ContestListData = useSelector((state) => state.matches.pool_list.data);
    const poolCreatedSelector = useSelector(state => state.matches.pool_add)
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(25);
    const [order, setOrder] = useState("asc");
    const [orderBy, setOrderBy] = useState("name");
    const [pzBkList,setPzBkList]=useState({});
    // const [joinAmount, setJoinAmount] = useState(0)
    // const [counter, setCounter] = useState(0)
    const [state, setState] = useState({
        ContestListData: [],
        totalCountPoolList: 0,
        logoImg: [],
        // joinfee: null,
        totalwinamt: null,
        maxteams: null,
        // winners: null,
        contest_id: null,
        pool_text: "Add Pool",
        countrytype: '+91',
        // contest_type: null,
        matchtype: location.state?.type,
        gtype: location.state?.gtype,
        makeContestConfirmed: false,
        teamType: false,
        openPzBk:false
    });

    const [poolPrizeStatus,setPoolPrizeStatus]=useState({});
    const [childOpen,setChildOpen]=useState(false);

    const [editState, setEditState] = useState({
        joinfee: null,
        totalwinamt: null,
        maxteams: null,
        // winners: null,
        pmin: null,
        pmax: null,
        pamount: null,
        poolmaster_id: null,

    });

    const handleClose = () => {
        setOpen(false);
    }

    const handleOpen = (data, value) => {
        setOpen(true);
        setEditState(value);
        setState({
            ...state,
            pool_text: data,
        });
    };

    const [formValues, setFormValues] = useState([
        { pmin: "", pmax: "", pamount: "", percentage: "", poolmaster_id: id },
    ]);

    let handleChange = (i, e) => {
        let newFormValues = [...formValues];
        newFormValues[i][e.target.id] = e.target.value;
        // if(e.target.id === "percentage"){
        //     newFormValues[i]["pamount"] = Math.round((state.totalwinamt * e.target.value) / 100);
        // }
        setFormValues(newFormValues);
    };

    let addFormFields = () => {
        setFormValues([
            ...formValues,
            { pmin: "", pmax: "", percentage: "", pamount: "", poolmaster_id: id },
        ]);
    };

    let removeFormFields = (i) => {
        let newFormValues = [...formValues];
        newFormValues.splice(i, 1);
        setFormValues(newFormValues);
    };

    const stateHandler = (key, value) => {
        state[key] = value;
        //editState[key] = value;
        //setEditState({ ...editState });
        setState({ ...state });
    };

    useEffect(() => {
        if (ContestListData !== undefined) {
            setState({
                ...state,
                ContestListData: ContestListData.data.poolmasterlist,
                totalCountPoolList: ContestListData.data.total_count,
            });
        }
    }, [ContestListData]);

    useEffect(() => {
        dispatch(GetPoolListAction(id, location.state.type, location.state.gtype, page, rowsPerPage));
    }, [dispatch, location.state.type, location.state.gtype, id, page, rowsPerPage]);

    useEffect(() => {
        if (Object.keys(statusSelector).length > 0) {
            dispatch(GetPoolListAction(id, location.state.type, location.state.gtype, page, rowsPerPage));
        }
    }, [statusSelector, dispatch, location.state.type, location.state.gtype, id, page, rowsPerPage]);

    useEffect(() => {
        if (Object.keys(poolCreatedSelector).length > 0) {
            if (poolCreatedSelector.data?.status) {
                dispatch(GetPoolListAction(id, location.state.type, location.state.gtype, page, rowsPerPage));
                setOpen(false)
                dispatch(ResetAddPoolAction())
            } else {
                toast.error(poolCreatedSelector.message)
            }
        }
    }, [poolCreatedSelector, dispatch, location.state.type, location.state.gtype, id, page, rowsPerPage]);

    const style = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "40%",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    const stylePzBk = {
        position: "absolute",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        width: "60%",
        bgcolor: "background.paper",
        border: "2px solid #000",
        boxShadow: 24,
        p: 4,
    };

    const handleRequestSort = (_, property) => {
        const isAsc = orderBy === property && order === "asc";
        setOrder(isAsc ? "desc" : "asc");
        setOrderBy(property);
    };

    const handleChangePage = (_, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value));
        setPage(0);
    };

    const submitContestFormData = (e) => {
        e.preventDefault();
        if (state.pool_text == "Add Pool") {
            if (
                // state.joinfee == null ||
                // state.contest_type == null ||
                state.totalwinamt == null ||
                state.maxteams == null ||
                // state.winners == null ||
                formValues.length == 0 ||
                formValues[0]?.pmin == "" ||
                formValues[0]?.pmax == "" ||
                formValues[0]?.pamount == ""
            ) {
                toast.error("All Filed Must be filled", { theme: "colored" });
            } else {
                let sendData = {
                    joinfee:state.joinfee, //Math.round(state.totalwinamt / state.maxteams),
                    totalwinamt: state.totalwinamt,
                    maxteams: state.maxteams,
                    // winners: state.winners,
                    contest_id: id,
                    type: state.matchtype,
                    countrytype: state.countrytype,
                    // contest_type: state.contest_type,
                    gtype: state.gtype,
                    c: state.makeContestConfirmed,
                    s: state.teamType === false ? 1 : 0,
                    m: state.teamType === true ? 1 : 0,
                };
                let sendPoolData = {
                    pool_prize_break_data: formValues,
                };
                setState({
                    ...state,
                    joinfee: "",
                    totalwinamt: "",
                    maxteams: "",
                    // winners: "",
                    makeContestConfirmed: false,
                    teamType: false,
                });

                dispatch(AddPoolAction(sendData, sendPoolData));
            }
        } else {
            setEditState({
                ...state,
                joinfee: "",
                totalwinamt: "",
                maxteams: "",
                // winners: "",
            });
        }
    };

    const activateContest = (event, status, poolmaster_id) => {
        event.preventDefault();
        let sendData = {
            poolmaster_id: poolmaster_id,
            status: status,
        };
        dispatch(PoolChangeStatusAction(sendData));
    };

    const InactivateContest = (event, status, poolmaster_id) => {
        event.preventDefault();
        let sendData = {
            poolmaster_id: poolmaster_id,
            status: status,
        };
        dispatch(PoolChangeStatusAction(sendData));
    };

    const handlePzBkClose=()=>{
        setOpenPzBk(false);
    }

    const ViewDetails = (data,countryId) => {
        setPzBkList({data,countryId});
        setOpenPzBk(true);
    };

    const onClickDelete=(event, status, _id)=>{
        
        setPoolPrizeStatus({event,status, _id})
        setChildOpen(true);
    }

    const onClickAction=()=>{
        
        activateContest(poolPrizeStatus.event, poolPrizeStatus.status, poolPrizeStatus._id)
        setChildOpen(false);
    }

    const handleChildClose=()=>{
        setChildOpen(false);
    }

    let createPoolBreakFileds = () => {
        return (
            <>
                {formValues.map((element, index) => {
                    return (
                        <React.Fragment key={index}>
                            <Grid xs={3}>
                                <TextField
                                    required
                                    type="number"
                                    onChange={(e) => handleChange(index, e)}
                                    value={element.pmin || ""}
                                    id="pmin"
                                    label="Min"
                                    fullWidth
                                    variant="outlined"
                                />
                            </Grid>
                            <Grid xs={3}>
                                <TextField
                                    required
                                    id="pmax"
                                    type="number"
                                    onChange={(e) => handleChange(index, e)}
                                    value={element.pmax || ""}
                                    label="Max"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            {/* <Grid xs={3}>
                                <TextField
                                    required
                                    id="percentage"
                                    type="number"
                                    onChange={(e) => handleChange(index, e)}
                                    value={element.percentage || ""}
                                    label="Percentage"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid> */}

                            <Grid xs={3}>
                                <TextField
                                    required
                                    id="pamount"
                                    type="number"
                                    onChange={(e) => handleChange(index, e)}
                                    value={element.pamount || ""}
                                    label="Amount"
                                    variant="outlined"
                                    fullWidth
                                />
                            </Grid>
                            <Grid xs={3}>
                                <Button
                                    align={"center"}
                                    onClick={() => removeFormFields(index)}
                                    variant="contained"
                                    fullWidth
                                >
                                    <Delete />
                                </Button>
                            </Grid>
                        </React.Fragment>
                    );
                })}
            </>
        );
    };
    return (
        <Page title="Pools">

            {loadingSelector ? <Loader /> : null}

            <Modal
                open={open}
                onClose={handleClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        {state.pool_text}
                    </Typography>
                    <Divider />
                    <Stack container spacing={3} style={{ marginTop: 30 }}>
                        <Grid container spacing={2}>
                            <Grid md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-helper-label">IN/UK</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value={state.countrytype}
                                        label="IN/UK"
                                        onChange={({ target }) => setState({ ...state, countrytype: target.value })}
                                    >
                                        <MenuItem value={"+91"}>India</MenuItem>
                                        <MenuItem value={"+1"}>Uk</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid>

                            <Grid md={6}>
                                <TextField
                                    onChange={({ target }) => stateHandler("totalwinamt", target.value)}
                                    type="number"
                                    id="outlined-basic"
                                    label="Winning amount"
                                    variant="outlined"
                                    defaultValue={
                                        editState && state.totalwinamt === null
                                            ? editState.totalwinamt
                                            : state.totalwinamt
                                    }
                                    fullWidth
                                />
                            </Grid>

                            <Grid md={6}>
                                <TextField
                                    onChange={({ target }) => stateHandler("maxteams", target.value)}
                                    type="number"
                                    id="outlined-basic"
                                    label="Max teams"
                                    variant="outlined"
                                    defaultValue={
                                        editState && state.maxteams === null
                                            ? editState.maxteams
                                            : state.maxteams
                                    }
                                    fullWidth
                                />
                            </Grid>

                            {/* <Grid md={6}>
                                <FormControl fullWidth>
                                    <InputLabel id="demo-simple-select-helper-label">Contest Type</InputLabel>
                                    <Select
                                        labelId="demo-simple-select-helper-label"
                                        id="demo-simple-select-helper"
                                        value={state.contest_type}
                                        label="Contest Type"
                                        onChange={({ target }) => setState({ ...state, contest_type: target.value })}
                                    >
                                        <MenuItem value="free">Free</MenuItem>
                                        <MenuItem value="paid">Paid</MenuItem>
                                    </Select>
                                </FormControl>
                            </Grid> */}

                            <Grid md={6}>
                                <TextField
                                    onChange={({ target }) => stateHandler("joinfee", target.value)}
                                    id="outlined-basic"
                                    label="Join fee"
                                    variant="outlined"
                                    inputProps={{ min: "0", max: "4" }}
                                    type="number"
                                    fullWidth
                                    defaultValue={
                                        editState && state.joinfee === null
                                            ? editState.joinfee
                                            : state.joinfee
                                    }
                                />
                                <TextField
                                    onChange={({ target }) => stateHandler("joinfee", target.value)}
                                    type="number"
                                    id="outlined-basic"
                                    label="Join fee"
                                    variant="outlined"
                                    defaultValue={
                                        editState && state.joinfee === null
                                            ? editState.joinfee
                                            : state.joinfee
                                    }
                                    fullWidth
                                />
                            </Grid>

                            {/* <Grid md={6}>
                                <TextField
                                    onChange={({ target }) => stateHandler("winners", target.value)}
                                    type="number"
                                    id="outlined-basic"
                                    label="Winners"
                                    variant="outlined"
                                    defaultValue={
                                        editState && state.winners === null
                                            ? editState.winners
                                            : state.winners
                                    }
                                    fullWidth
                                />
                            </Grid> */}

                            {createPoolBreakFileds()}

                            <Grid xs={12}>
                                <div align="right">
                                    <Button
                                        onClick={() => addFormFields()}
                                        variant="contained"
                                    > Add prize </Button>
                                </div>
                            </Grid>

                            <Grid xs={12}>
                                <FormGroup>
                                    <FormControlLabel control={
                                        <Checkbox name="makeContestConfirmed" onChange={({ target }) => stateHandler("makeContestConfirmed", target.checked)} />
                                    } label="Confirmed winning even if the contest remains unfilled." />
                                    <FormControlLabel control={
                                        <Checkbox name="teamType" onChange={({ target }) => stateHandler("teamType", target.checked)} />
                                    } label="Join with multiple teams." />
                                </FormGroup>
                            </Grid>
                        </Grid>

                        <Button
                            align={"center"}
                            style={{ marginTop: 20, width: "100%" }}
                            variant="contained"
                            onClick={(e) => submitContestFormData(e)}
                        >
                            {state.pool_text}
                        </Button>
                    </Stack>
                </Box>
            </Modal>

            <Container maxWidth="lg">
                <Box sx={{ flexGrow: 1 }}>
                    <Grid container spacing={2}>
                        <Grid xs={10}>
                            <HeaderBreadcrumbs
                                heading={`${location.state.name} Pool Contest List`}
                                links={[
                                    { name: "Dashboard", href: "/dashboard/app" },
                                    { name: "Contest List", href: "/dashboard/cricket/contest_list" },
                                    { name: "Pools" },
                                ]}
                            />
                        </Grid>
                        <Grid xs={2}>
                            <div align="right">
                                <Button
                                    // onClick={() => handleOpen("Add Pool")}
                                    onClick={() => navigate(`/dashboard/pool/${state.gtype}/${id}/create`, { state: { match_type: location.state.type, name: location.state.name } }, { replace: true })}
                                    variant="contained"
                                >
                                    Add Pool
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                </Box>

                <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: "c_title", label: "Fee", alignRight: false },
                                        { id: "c_subtitle", label: "Total Winning", alignRight: false },
                                        { id: "c_bonus", label: "Max Team", alignRight: false },
                                        { id: "c_country", label: "Country Code", alignRight: false },
                                        { id: "c_status", label: "Status", alignRight: false },
                                        { id: "c_bkpz", label: "Breakup View", alignRight: false },
                                        { id: "c_delete", label: "Delete", alignRight: false },
                                    ]}
                                    rowCount={state.totalCountPoolList}
                                // onRequestSort={handleRequestSort}
                                />
                                <TableBody>
                                    {state?.ContestListData?.map((data, index) => {
                                        return (
                                            <TableRow key={index}>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {page * rowsPerPage + (index + 1)}.
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.joinfee}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.totalwinamt}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {data.maxteams}
                                                </TableCell>
                                                <TableCell
                                                    component="th"
                                                    scope="row"
                                                >
                                                    {(data.countrytype=="+91")&&"IN"}
                                                    {(data.countrytype=="+1")&&"UK"}
                                                </TableCell>
                                                <TableCell component="th" scope="row">
                                                    {data.status === 1 ? (
                                                        <Button
                                                            size="small"
                                                            color="success"
                                                            onClick={(event) =>
                                                                activateContest(event, 0, data._id)
                                                            }
                                                        >
                                                            Active
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            size="small"
                                                            color="error"
                                                            onClick={(event) =>
                                                                InactivateContest(event, 1, data._id)
                                                            }
                                                        >
                                                            Inactive
                                                        </Button>
                                                    )}
                                                </TableCell>
                                                <TableCell>
                                                    <Button onClick={() => ViewDetails(data.poolpzbk,data.countrytype)}>
                                                            <Iconify
                                                                icon="eva:eye-fill"
                                                                width={24}
                                                                height={24}
                                                            />
                                                    </Button>
                                                </TableCell>
                                                <TableCell>
                                                    {data.status === 0 && <Button onClick={(event) =>onClickDelete(event, 2, data._id)}>
                                                            <Iconify
                                                                icon="material-symbols:delete"
                                                                width={24}
                                                                height={24}
                                                            />
                                                    </Button>}
                                                </TableCell>
                                                {/* <TableCell>
                                                    <Button
                                                        size="small"
                                                        color="primary"
                                                        onClick={() => handleOpen("Edit Pool", data)}
                                                    >
                                                        <BorderColorOutlined />
                                                    </Button>
                                                    <Button size="small" color="error" onClick={(event) => InactivateContest(event, 2, data._id)}>Delete</Button>
                                                </TableCell> */}
                                            </TableRow>
                                        )

                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Scrollbar>

                    <TablePagination
                        rowsPerPageOptions={[25, 50, 100, 150, 200]}
                        component="div"
                        count={state.totalCountPoolList}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                    />
                </Card>
            </Container>

            <Modal
                open={openPzBk}
                onClose={handlePzBkClose}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={stylePzBk}>
                    <Typography
                        id="modal-modal-title"
                        style={{ marginBottom: 20 }}
                        align={"center"}
                        variant="h6"
                        component="h2"
                    >
                        Prize Breakup - 
                        {(pzBkList.countryId=="+91")&&"IN"}
                        {(pzBkList.countryId=="+1")&&"UK"}
                    </Typography>
                    <Divider />
                    <Stack container spacing={3} style={{ marginTop: 30 }}>
                    <Card>
                    <Scrollbar>
                        <TableContainer sx={{ minWidth: 800 }}>
                            <Table>
                                <UserListHead
                                    order={order}
                                    orderBy={orderBy}
                                    headLabel={[
                                        { id: "c_no", label: "Sr no.", alignRight: false },
                                        { id: "c_title", label: "Min", alignRight: false },
                                        { id: "c_subtitle", label: "Max", alignRight: false },
                                        { id: "c_bonus", label: "Amount", alignRight: false }
                                    ]}
                                    rowCount={state.totalCountPoolList}
                                // onRequestSort={handleRequestSort}
                                />
                    <TableBody>
                        {pzBkList && pzBkList.data && pzBkList.data.map((item,index)=>(
                            <TableRow>
                                <TableCell>
                                {index+1}
                                </TableCell>
                                <TableCell>
                                {item.pmin}
                                </TableCell>
                                <TableCell>
                                {item.pmax}
                                </TableCell>
                                <TableCell>
                                {item.pamount}
                                </TableCell>
                            </TableRow>))}
                    </TableBody>
                    </Table>
                    </TableContainer>
                    </Scrollbar>
                    </Card>
                        <Grid xs={12}>
                                <div align="right">
                                    <Button
                                        onClick={() => handlePzBkClose()}
                                        variant="contained"
                                    > Close </Button>
                                </div>
                            </Grid>

                            
                    </Stack>
                </Box>
            </Modal>

            <Modal
          open={childOpen}
          aria-labelledby="child-modal-title"
          aria-describedby="child-modal-description"
        >
          <Box sx={{ ...style, width: 500 }}>
            <h2 id="child-modal-title">Are you sure, you want to delete?</h2>
            <p id="child-modal-description">
            </p>
            <div style={{ marginTop: 20, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Button  onClick={handleChildClose}>Close</Button>
            <Button variant="contained" color={"error"} onClick={onClickAction}>Delete</Button>
                        </div>
            
          </Box>
        </Modal>
        </Page>
    );
}